/**
 * When an Edge Function returns 4xx/5xx, @supabase/functions-js returns FunctionsHttpError
 * with context = the fetch Response. The JSON body is often `{ error: string }` from our functions.
 * We extract the actual error message from the response body so the user sees e.g.
 * "Saldo insuficiente no cartão" instead of "Edge Function returned a non-2xx status code".
 */
export async function getEdgeFunctionErrorMessage(
  error: unknown,
  response?: Response | null,
  fallback = "Erro ao comunicar com o servidor",
): Promise<string> {
  const res = response ?? (error as { context?: Response })?.context;
  if (res && typeof res.json === "function") {
    try {
      const ct = res.headers.get("Content-Type") || "";
      if (ct.includes("application/json")) {
        const body = await res.clone().json();
        if (typeof body?.error === "string" && body.error.trim()) {
          return body.error.trim();
        }
        if (typeof body?.message === "string" && body.message.trim()) {
          return body.message.trim();
        }
      }
    } catch {
      /* ignore parse errors */
    }
  }
  if (error instanceof Error && error.message?.trim()) {
    return error.message;
  }
  return fallback;
}
